import { useEffect, useState } from "react";
import CountryController from "../controllers/CountryController";
import Country from "../models/Country";
import { usePlan } from "../_providers/PlanProvider";
import { useModal } from "../_providers/ModalProvider";

export const AddKeyValueModal = (props: {onCreate: (key: string, value: string) => void}) => {
    const {closeModal} = useModal();

    const [key, setKey] = useState<string>("");
    const [value, setValue] = useState<string>("");

    return (
        <div>
            <input
                type="text"
                placeholder="Key"
                value={key}
                onChange={(e) => setKey(e.target.value)}
            />
            <input
                type="text"
                placeholder="Value"
                value={value}
                onChange={(e) => setValue(e.target.value)}
            />
            <button onClick={() => {props.onCreate(key, value); closeModal()}}>Add</button>
        </div>
    )
}